import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';
import { validatePayment } from './utils';

export default function* listenSetPayment() {
  yield takeEvery(actions.setPayment.type, validatePayment);
}
